<template>
  <div>
    <h2>{{ upcomingEventsStr }}</h2>
    <div v-if="noUpcomingEvents">
      <p>{{ noUpcomingEventsStr }}</p>
    </div>
    <div v-else>
      <event-list :data="upcomingEvents"></event-list>
    </div>
    <!-- <h2>{{ pastEventsStr }}</h2>
      <event-list :data="pastEvents"></event-list> -->
  </div>
</template>

<script>
import EventList from "./EventList.vue";

export default {
  components: {
    EventList,
  },
  props: {
    data: {
      type: Array,
      default: () => {},
      required: true,
    },
  },
  computed: {
    today() {
      return new Date();
    },
    yesterday() {
      return this.today.setDate(this.today.getDate() - 1);
    },
    upcomingEvents() {
      return this.data.filter(
        (event) => event.Date > this.yesterday
      );
      //   } else return null;
    },
    noUpcomingEvents() {
      return this.upcomingEvents.length == 0;
    },
    noUpcomingEventsStr() {
      if (this.$language == "de") {
        return "Zurzeit gibt es keine bevorstehenden Veranstaltungen.";
      }
      if (this.$language == "en") {
        return "No upcoming events at the moment.";
      }
      if (this.$language == "fr") {
        return "Il n'y a pas d'événements à venir pour le moment.";
      }
      if (this.$language == "it") {
        return "Attualmente non ci sono eventi in programma.";
      } else return "";
    },
    upcomingEventsStr() {
      if (this.$language == "de") {
        return "Bevorstehende Veranstaltungen";
      }
      if (this.$language == "en") {
        return "Upcoming Events";
      }
      if (this.$language == "fr") {
        return "Événements à venir";
      }
      if (this.$language == "it") {
        return "Prossimi eventi";
      } else return "";
    },
    // pastEvents() {
    //   if (this.mediaType == "events") {
    //     return this.sortedData.filter((event) => event.Date < this.today);
    //   } else return null;
    // },
    // pastEventsStr() {
    //   if (this.$language == "de") {
    //     return "Vergangene Veranstaltungen";
    //   }
    //   if (this.$language == "en") {
    //     return "Past Events";
    //   }
    //   if (this.$language == "fr") {
    //     return "Événements passés";
    //   }
    //   if (this.$language == "it") {
    //     return "Eventi passati";
    //   } else return "";
    // },
  },
};
</script>